import { useState, useRef, useEffect } from 'react';
import { musicalStyles } from '../../../mocks/home';

export default function MusicalStyles() {
  const [playingId, setPlayingId] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const onEnded = () => setPlayingId(null);
    audio.addEventListener('ended', onEnded);
    return () => audio.removeEventListener('ended', onEnded);
  }, []);

  const togglePlay = (id: string, audioUrl: string) => {
    if (!audioRef.current || !audioUrl) return;

    if (playingId === id) {
      audioRef.current.pause();
      setPlayingId(null);
    } else {
      audioRef.current.src = audioUrl;
      audioRef.current.play();
      setPlayingId(id);
    }
  };

  return (
    <section id="estilos" className="py-28" style={{ background: 'transparent' }}>
      <audio ref={audioRef} preload="none" />
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span
            className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mb-4"
            style={{ background: 'var(--badge-bg)', color: 'var(--gold-hover)', fontFamily: "'DM Sans', sans-serif", border: '1px solid rgba(200,131,42,0.15)' }}
          >
            Para todo ritmo do Brasil
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
          >
            Qual o estilo musical dela?
          </h2>
          <p
            className="text-base max-w-md mx-auto"
            style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            Ouça os exemplos! Clique no ritmo que mais combina e receba uma música feita no estilo favorito dessa pessoa.
          </p>
        </div>

        <div className="flex flex-wrap gap-4 justify-center max-w-4xl mx-auto mb-8">
          {musicalStyles.map((style) => {
            const isPlaying = playingId === style.id;
            return (
              <button
                key={style.id}
                onClick={() => togglePlay(style.id, style.audioUrl)}
                disabled={!style.audioUrl}
                className="flex items-center gap-2.5 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap group hover:-translate-y-1"
                style={{
                  background: isPlaying ? 'var(--gold)' : 'var(--surface-white)',
                  color: isPlaying ? '#fff' : 'var(--earth-strong)',
                  border: `1.5px solid ${isPlaying ? 'var(--gold)' : 'rgba(200,131,42,0.2)'}`,
                  fontFamily: "'DM Sans', sans-serif",
                  boxShadow: isPlaying ? '0 8px 24px rgba(200,131,42,0.3)' : '0 4px 12px rgba(0,0,0,0.03)',
                  cursor: style.audioUrl ? 'pointer' : 'default',
                  opacity: style.audioUrl ? 1 : 0.5,
                }}
              >
                <i 
                  className={`ri-${isPlaying ? 'pause' : 'play'}-circle-fill text-xl duration-200`} 
                  style={{ color: isPlaying ? '#fff' : 'var(--gold)' }}
                />
                {style.label}
              </button>
            );
          })}
        </div>

        <p
          className="text-center text-sm mt-8"
          style={{ color: 'var(--text-soft)', fontFamily: "'DM Sans', sans-serif" }}
        >
          {playingId 
            ? 'Tocando uma amostra de demonstração agora...' 
            : 'Clique no ícone de play em qualquer botão acima para ouvir'}
        </p>
      </div>
    </section>
  );
}
